module.exports = __webpack_public_path__ + "static/media/add student inquiry.55191b4d.svg";